import { getSiteURL } from '@/lib/get-site-url';
import { LogLevel } from '@/lib/logger';

export interface Config {
  site: { name: string; description: string; themeColor: string; url: string };
  logLevel: keyof typeof LogLevel;
  api: {
    baseUrl: string;
    version: string;
  };
  app: {
    title: string;
    env: string;
  };
}

export const config: Config = {
  site: { 
    name: import.meta.env.VITE_APP_TITLE || 'Fantek Admin', 
    description: '', 
    themeColor: '#090a0b', 
    url: getSiteURL() 
  },
  logLevel: (import.meta.env.VITE_LOG_LEVEL as keyof typeof LogLevel) ?? LogLevel.ALL,
  api: {
    baseUrl: import.meta.env.VITE_API_URL || 'https://fantek-60c47e42f904.herokuapp.com',
    version: import.meta.env.VITE_VERSION || 'v1',
  },
  app: {
    title: import.meta.env.VITE_APP_TITLE || 'Fantek Admin',
    env: import.meta.env.VITE_APP_ENV || 'production',
  },
};
